
import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"


import moduleOrderList from "./modules/moduleOrderList"
import moduleNotification from './modules/moduleNotification'
import moduleTransaction from './modules/moduleTransaction'
import moduleChatList from "./modules/moduleChatList"

Vue.use(Vuex)

export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations,
    modules: {
        orderList:moduleOrderList,
        notification:moduleNotification,
        transaction:moduleTransaction,
        chatList:moduleChatList,
    },
    strict: process.env.NODE_ENV !== 'production'
})

